import script from "./seller-sales.vue?vue&type=script&setup=true&lang=js"
export * from "./seller-sales.vue?vue&type=script&setup=true&lang=js"

import "./seller-sales.vue?vue&type=style&index=0&id=5606cf9c&scoped=true&lang=postcss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5606cf9c"]])

export default __exports__